import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cn } from '@lib/utils';

interface SeparatorProps
  extends React.ComponentProps<typeof SeparatorPrimitive.Root> {
  dot?: boolean;
}

function Separator({
  className,
  orientation = 'horizontal',
  decorative = true,
  dot = false,
  style,
  ...props
}: SeparatorProps) {
  return (
    <SeparatorPrimitive.Root
      className={cn(
        dot
          ? 'w-[3px] h-[3px] rounded-full bg-border'
          : 'bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        className
      )}
      data-slot="separator-root"
      decorative={decorative}
      orientation={orientation}
      style={dot ? { width: '3px', height: '3px', ...style } : style}
      {...props}
    />
  );
}

export { Separator };
